export function Logo({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" data-testid="brand-logo">
      <ellipse cx="32" cy="38" rx="12" ry="15" fill="#D97706" />
      <path d="M24 32h16M23 39h18M25 46h14" stroke="#2C221E" strokeWidth="3.2" strokeLinecap="round" />
      <circle cx="32" cy="19" r="6.5" fill="#2C221E" />
      <ellipse cx="22" cy="22" rx="8" ry="5" fill="#F3EBE0" fillOpacity="0.9" transform="rotate(-28 22 22)" />
      <ellipse cx="42" cy="22" rx="8" ry="5" fill="#F3EBE0" fillOpacity="0.9" transform="rotate(28 42 22)" />
      <path d="M28 14c-1-3-3-5-5-6M36 14c1-3 3-5 5-6" stroke="#2C221E" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
